// services/UserService.js
import http from "./AxiosInstance";

class UserService {
  // Récupérer tous les utilisateurs
  getAllUsers() {
    return http.get("/users/all");
  }

  // Récupérer les rôles
  getRoles() {
    return http.get("/users/roles");
  }

  // Créer un rôle
  createRole(data) {
    return http.post("/users/role/create", data);
  }

  // Supprimer un rôle
  deleteRole(rol) {
    return http.delete(`/users/role/delete/${rol}`);
  }

  // Créer un utilisateur
  createUser(data) {
    return http.post("/users/register", data);
  }

  // Mettre à jour un utilisateur (pour les admins)
  updateUser(id, data) {
    console.log(id,data)
    return http.put(`/users/${id}`, data);
  }

  // Supprimer un utilisateur
  deleteUser(id) {
    return http.delete(`/users/${id}`);
  }

  // Récupérer le profil utilisateur
  getUserProfile(id) {
    return http.get(`/users/${id}`);
  }

  // Changer le mot de passe
  changePassword(id, passwordData) {
    return http.put(`/users/${id}/password`, passwordData);
  }

  // Mettre à jour le profil utilisateur (pour l'utilisateur connecté)
  updateProfile(id, profileData) {
    // Utiliser la même route que updateUser mais avec les données adaptées
    return http.put(`/users/${id}`, profileData);
  }
}

const userService = new UserService();
export default userService;